import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const CreationDocsInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const { form, onFieldsChange, implementerProfile } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Documentos de creación">
      {getFieldDecorator("creationDocs", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa los documentos de creación."
          }
        ],
        initialValue: ""
      })(
        <Input
          id="creationDocs"
          name="creationDocs"
          placeholder="Documentos de creación"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
